// 技術日報 print template — clean single-sheet A4 layout.
import { formatJST, formatJSTLocale } from '@/utils/datetime';

const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (ch) => (
  { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

const line = (s) => esc(s).replace(/\n/g, '<br>');

const FIELD_ORDER = [
  ['objective', '本日の目標'],
  ['problem', '取り組んでいる課題'],
  ['actions', '実施した作業'],
  ['rationale', '技術的根拠'],
  ['result', '成果'],
  ['blockers', 'ブロッカー'],
  ['next_step', '次のステップ'],
  ['lessons', '教訓・学び'],
];

export function buildReportPrintHtml(report) {
  const dt = report.report_date || '';
  const proj = report.project_name || '（プロジェクト未指定 — 汎用作業）';
  const dept = report.department_name || '';
  const engineer = report.engineer_name || '';
  const state = ({ draft: '下書き', submitted: '提出済み' })[report.report_status] || report.report_status || '';
  const statusLabel = ({ in_progress: '進行中', completed: '完了', blocked: 'ブロック中' })[report.status] || report.status || '';

  const rows = FIELD_ORDER.map(([k, label]) => {
    const v = (report[k] || '').trim();
    if (!v) return '';
    return `<tr><th>${esc(label)}</th><td>${line(v)}</td></tr>`;
  }).join('');

  const attach = (report.attachments || []).length > 0
    ? `<tr><th>添付ファイル</th><td>${report.attachments.map((a) => esc(a.filename)).join(' / ')}</td></tr>`
    : '';

  return `<!DOCTYPE html><html lang="ja"><head><meta charset="utf-8"><title>技術日報 ${esc(dt)} — ${esc(engineer)}</title>
<style>
  @page { size: A4; margin: 15mm; }
  * { box-sizing: border-box; }
  body { font-family: -apple-system, "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
         color: #18181b; margin: 0; font-size: 12px; line-height: 1.55; }
  header { display: flex; justify-content: space-between; align-items: baseline; border-bottom: 3px double #0f766e; padding-bottom: 6px; margin-bottom: 14px; }
  header h1 { margin: 0; font-size: 20px; letter-spacing: 0.5px; }
  header .brand { font-size: 11px; color: #71717a; letter-spacing: 1px; }
  .meta { display: grid; grid-template-columns: 90px 1fr 90px 1fr; gap: 4px 12px; font-size: 11px;
          background: #f4f4f5; padding: 8px 12px; border-radius: 6px; margin-bottom: 14px; }
  .meta b { color: #52525b; font-weight: 600; }
  table { width: 100%; border-collapse: collapse; }
  th, td { border: 1px solid #d4d4d8; padding: 8px 10px; vertical-align: top; text-align: left; }
  th { background: #f4f4f5; width: 24%; font-weight: 600; color: #3f3f46; font-size: 11px; letter-spacing: 0.3px; }
  td { white-space: pre-wrap; word-break: break-word; }
  .footer { margin-top: 18px; text-align: right; font-size: 10px; color: #a1a1aa; }
  @media print { body { print-color-adjust: exact; -webkit-print-color-adjust: exact; } }
</style></head>
<body>
<header>
  <h1>技術日報</h1>
  <div class="brand">SENSBEY ／ 技術</div>
</header>
<div class="meta">
  <b>日付</b><span>${esc(dt)}</span>
  <b>状態</b><span>${esc(state)} ／ ${esc(statusLabel)}</span>
  <b>プロジェクト</b><span>${esc(proj)}</span>
  <b>部署</b><span>${esc(dept)}</span>
  <b>技術者</b><span>${esc(engineer)}</span>
  <b>提出日時</b><span>${esc(formatJST(report.submitted_at))}</span>
</div>
<table>
  ${rows || '<tr><td colspan="2" style="text-align:center;color:#a1a1aa">内容がありません</td></tr>'}
  ${attach}
</table>
<p class="footer">Sensbey Web App（統合業務プラットフォーム）— 技術 / 日報より自動生成 · ${esc(formatJSTLocale(new Date()))}</p>
</body></html>`;
}
